(function () {
  'use strict';

  var EFFECT_BY_HANDLE = {
    'bead-rose-quartz': 'Love',
    'bead-amethyst': 'Clarity',
    'bead-tiger-eye': 'Protection',
    'bead-lapis-lazuli': 'Clarity',
    'bead-citrine': 'Wealth',
    'bead-jade': 'Wealth',
    'bead-moonstone': 'Clarity',
    'bead-labradorite': 'Clarity',
    'bead-black-obsidian': 'Protection',
    'bead-carnelian': 'Wealth'
  };

  var ENERGY_BY_HANDLE = {
    'bead-amethyst': 'Intuition & calm',
    'bead-rose-quartz': 'Love & harmony',
    'bead-tiger-eye': 'Courage & focus',
    'bead-lapis-lazuli': 'Wisdom & truth',
    'bead-citrine': 'Abundance & joy',
    'bead-jade': 'Growth & healing',
    'bead-moonstone': 'New beginnings',
    'bead-labradorite': 'Transformation',
    'bead-black-obsidian': 'Protection',
    'bead-carnelian': 'Passion & vitality'
  };

  var REFERENCE_SIZE_MM = 10;
  var MIN_SIZE_MM = 5;
  var MAX_SIZE_MM = 10;
  /** Minimum preview ring ≈ full bracelet with this many typical 8mm beads */
  var MIN_RING_BEAD_COUNT = 18;
  var MIN_RING_BEAD_MM = 8;

  function stableSizeMm(handle) {
    if (!handle) return REFERENCE_SIZE_MM;
    var hash = 0;
    for (var i = 0; i < handle.length; i++) {
      hash = ((hash * 31) + handle.charCodeAt(i)) | 0;
      hash = hash & 0x7fffffff;
    }
    return MIN_SIZE_MM + (hash % (MAX_SIZE_MM - MIN_SIZE_MM + 1));
  }

  function normalizeSizeMm(bead) {
    var size = parseInt(bead && bead.sizeMm, 10);
    if (!size || size < MIN_SIZE_MM || size > MAX_SIZE_MM) {
      size = stableSizeMm(bead && bead.handle);
    }
    return size;
  }

  function mapEffect(bead) {
    if (bead.effect) return bead.effect;
    if (bead.handle && EFFECT_BY_HANDLE[bead.handle]) return EFFECT_BY_HANDLE[bead.handle];
    return 'Clarity';
  }

  function moyshopDesignerFactory() {
    return {
      loading: true,
      cartLoading: false,
      beads: [],
      selectedBeads: [],
      ringRadius: 200,
      previewScale: 1,
      saveNotice: '',
      mobileTab: 'preview',
      isMobile: false,
      searchQuery: '',
      activeFilter: 'All',
      filters: ['All', 'Wealth', 'Love', 'Protection', 'Clarity'],
      customVariantId: null,
      basePrice: 5,
      maxBeads: 60,
      moneyFormat: '${{amount}}',

      init: function () {
        if (this._msInitialized) return;
        this._msInitialized = true;

        var cfgEl = document.getElementById('moyshop-builder-config');
        if (cfgEl) {
          try {
            var cfg = JSON.parse(cfgEl.textContent);
            this.customVariantId = cfg.customVariantId;
            this.basePrice = cfg.basePrice || 5;
            this.maxBeads = cfg.maxBeads || 60;
            this.moneyFormat = cfg.moneyFormat || this.moneyFormat;
          } catch (e) { /* ignore */ }
        }

        var catalogEl = document.getElementById('moyshop-bead-catalog');
        if (catalogEl) {
          try {
            var raw = JSON.parse(catalogEl.textContent) || [];
            this.beads = raw.map(function (b) {
              b.effect = mapEffect(b);
              b.energy = b.energy || (b.handle && ENERGY_BY_HANDLE[b.handle]) || b.effect;
              b.sizeMm = normalizeSizeMm(b);
              return b;
            });
          } catch (e) {
            this.beads = [];
          }
        }

        this.loading = false;
        var self = this;
        this.checkMobile();
        this._onResize = function () {
          self.checkMobile();
          self.updateRingRadius();
        };
        window.addEventListener('resize', this._onResize);
        this.$nextTick(function () {
          self.updateRingRadius();
          self.restoreSavedDesign();
        });
      },

      destroy: function () {
        if (this._onResize) window.removeEventListener('resize', this._onResize);
      },

      get filteredBeads() {
        var q = (this.searchQuery || '').toLowerCase().trim();
        var filter = this.activeFilter;
        return this.beads.filter(function (b) {
          if (filter !== 'All' && b.effect !== filter) return false;
          if (!q) return true;
          return (b.name || '').toLowerCase().indexOf(q) !== -1 ||
            (b.energy || '').toLowerCase().indexOf(q) !== -1 ||
            (b.effect || '').toLowerCase().indexOf(q) !== -1;
        });
      },

      get beadsSubtotal() {
        return this.selectedBeads.reduce(function (acc, b) { return acc + b.price; }, 0);
      },

      get groupedBeads() {
        var groups = {};
        this.selectedBeads.forEach(function (b) {
          if (!groups[b.id]) {
            groups[b.id] = {
              id: b.id,
              name: b.name,
              effect: b.effect,
              energy: b.energy,
              image: b.image,
              price: b.price,
              sizeMm: b.sizeMm,
              qty: 0,
              total: 0
            };
          }
          groups[b.id].qty += 1;
          groups[b.id].total += b.price;
        });
        return Object.keys(groups).map(function (key) { return groups[key]; });
      },

      get totalPrice() {
        return this.basePrice + this.beadsSubtotal;
      },

      get payloadJson() {
        if (!this.selectedBeads.length) return '';
        return JSON.stringify({
          beads: this.selectedBeads.map(function (b) { return b.id; })
        });
      },

      formatMoney: function (amount) {
        var n = Number(amount).toFixed(2);
        return this.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, n).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(amount));
      },

      formatBeadSize: function (sizeMm) {
        return normalizeSizeMm({ sizeMm: sizeMm }) + 'mm';
      },

      beadBasePx: function (bead) {
        var sizeMm = normalizeSizeMm(bead);
        var base = this.isMobile ? 54 : 64;
        return Math.max(24, Math.round(base * (sizeMm / REFERENCE_SIZE_MM)));
      },

      beadPreviewPx: function (bead) {
        return Math.max(10, Math.round(this.beadBasePx(bead) * (this.previewScale || 1)));
      },

      checkMobile: function () {
        this.isMobile = window.matchMedia('(max-width: 1023px)').matches;
      },

      scheduleRingUpdate: function () {
        var self = this;
        this.$nextTick(function () {
          self.updateRingRadius();
        });
      },

      updateRingRadius: function () {
        var el = this.$refs.ringStage;
        if (!el) return;

        var stageSize = Math.min(el.offsetWidth, el.offsetHeight);
        if (this.isMobile) {
          stageSize = Math.min(stageSize, window.innerWidth - 40, window.innerHeight * 0.5);
        }

        // Floor radius ≈ 18 × 8mm beads packed on a circle (matches a full classic bracelet)
        var refBeadPx = Math.max(24, Math.round((this.isMobile ? 54 : 64) * (MIN_RING_BEAD_MM / REFERENCE_SIZE_MM)));
        var minRadius = (MIN_RING_BEAD_COUNT * refBeadPx) / (2 * Math.PI);

        var beads = this.selectedBeads;
        if (!beads.length) {
          this.previewScale = 1;
          var emptyNeeded = minRadius * 2 + refBeadPx + 24;
          var emptyAvailable = Math.max(120, stageSize * 0.92);
          var emptyScale = emptyNeeded > emptyAvailable ? emptyAvailable / emptyNeeded : 1;
          this.previewScale = emptyScale;
          this.ringRadius = Math.max(36, Math.round(minRadius * emptyScale));
          return;
        }

        // Scheme A: circumference ≈ sum of bead diameters → radius = sum / (2π)
        var totalPx = 0;
        var maxBead = 0;
        for (var i = 0; i < beads.length; i++) {
          var px = this.beadBasePx(beads[i]);
          totalPx += px;
          if (px > maxBead) maxBead = px;
        }

        var idealRadius = Math.max(totalPx / (2 * Math.PI), minRadius);
        var diameterNeeded = idealRadius * 2 + maxBead + 24;
        var available = Math.max(120, stageSize * 0.92);
        var scale = 1;
        if (diameterNeeded > available) {
          scale = available / diameterNeeded;
        }

        this.previewScale = scale;
        this.ringRadius = Math.max(36, Math.round(idealRadius * scale));
      },

      addBead: function (bead) {
        if (this.selectedBeads.length >= this.maxBeads) {
          alert('Maximum ' + this.maxBeads + ' beads per bracelet.');
          return;
        }
        this.selectedBeads.push(Object.assign({}, bead, { uniqueKey: Date.now() + Math.random() }));
        this.saveNotice = '';
        this.scheduleRingUpdate();
      },

      removeBead: function (index) {
        this.selectedBeads.splice(index, 1);
        this.saveNotice = '';
        this.scheduleRingUpdate();
      },

      moveBead: function (index, direction) {
        var newIndex = index + direction;
        if (newIndex < 0 || newIndex >= this.selectedBeads.length) return;
        var item = this.selectedBeads.splice(index, 1)[0];
        this.selectedBeads.splice(newIndex, 0, item);
        this.scheduleRingUpdate();
      },

      clearAll: function () {
        if (!this.selectedBeads.length) return;
        if (window.confirm('Clear all beads from this design?')) {
          this.selectedBeads = [];
          this.saveNotice = '';
          this.scheduleRingUpdate();
        }
      },

      getInspiration: function () {
        if (!this.beads.length) return;
        this.selectedBeads = [];
        var pool = this.beads.slice();
        var count = Math.min(8, this.maxBeads, pool.length);
        for (var i = 0; i < count; i++) {
          var idx = Math.floor(Math.random() * pool.length);
          this.addBead(pool[idx]);
        }
      },

      saveDesign: function () {
        if (!this.selectedBeads.length) {
          alert('Your bracelet is empty.');
          return;
        }
        try {
          localStorage.setItem('moyshop_bracelet_design', this.payloadJson);
          this.saveNotice = 'Design saved locally.';
        } catch (e) {
          this.saveNotice = 'Could not save design.';
        }
      },

      restoreSavedDesign: function () {
        try {
          var raw = localStorage.getItem('moyshop_bracelet_design');
          if (!raw) return;
          var data = JSON.parse(raw);
          if (!data || !data.beads || !data.beads.length) return;
          var self = this;
          this.selectedBeads = [];
          data.beads.forEach(function (id) {
            var bead = self.beads.find(function (b) { return b.id === id; });
            if (bead) self.addBead(bead);
          });
        } catch (e) { /* ignore */ }
      },

      calculateBeadPosition: function (index) {
        var beads = this.selectedBeads;
        var count = beads.length;
        if (!count) return '';

        // Place centers by arc length proportional to each bead's diameter
        var sizes = [];
        var total = 0;
        for (var i = 0; i < count; i++) {
          var s = this.beadBasePx(beads[i]);
          sizes.push(s);
          total += s;
        }
        var cum = 0;
        for (var j = 0; j < index; j++) cum += sizes[j];
        var mid = cum + sizes[index] / 2;
        var angle = (mid / total) * 360 - 90;
        var radian = angle * (Math.PI / 180);
        var radius = this.ringRadius;
        var x = Math.cos(radian) * radius;
        var y = Math.sin(radian) * radius;
        return 'transform: translate(' + x + 'px, ' + y + 'px);';
      },

      beadRingStyle: function (index, bead) {
        var pos = this.calculateBeadPosition(index);
        var px = this.beadPreviewPx(bead);
        var half = px / 2;
        return pos + ' width:' + px + 'px;height:' + px + 'px;margin-left:-' + half + 'px;margin-top:-' + half + 'px;';
      },

      ringTrackSize: function () {
        return (this.ringRadius * 2 + 80) + 'px';
      },

      addToBag: function () {
        if (!this.selectedBeads.length) {
          alert('Please add at least one bead before adding to cart.');
          return;
        }
        if (!this.customVariantId) {
          alert('Custom bracelet product is not configured.');
          return;
        }

        var self = this;
        self.cartLoading = true;

        var design = this.selectedBeads.map(function (b) { return b.name; }).join(' → ');
        var grouped = this.groupedBeads.map(function (g) {
          return g.name + ' (' + self.formatBeadSize(g.sizeMm) + ') x' + g.qty + ' @ ' + self.formatMoney(g.price);
        }).join('; ');

        var items = [{
          id: this.customVariantId,
          quantity: 1,
          properties: {
            Design: design,
            Beads: grouped,
            'Total beads': String(this.selectedBeads.length)
          }
        }];

        var counts = {};
        this.selectedBeads.forEach(function (b) {
          counts[b.id] = (counts[b.id] || 0) + 1;
        });
        Object.keys(counts).forEach(function (id) {
          items.push({ id: parseInt(id, 10), quantity: counts[id] });
        });

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('Cart error');
            return r.json();
          })
          .then(function () {
            window.location.href = root + 'cart';
          })
          .catch(function () {
            alert('Could not add to cart. Please try again.');
          })
          .finally(function () {
            self.cartLoading = false;
          });
      }
    };
  }

  window.moyshopDesigner = moyshopDesignerFactory;

  document.addEventListener('alpine:init', function () {
    Alpine.data('moyshopDesigner', moyshopDesignerFactory);
  });
})();
